import { useEffect } from "react";
import Dataset from "datasets/types/interfaces/dataset";
import { trackEvent } from "~/utils/monitoring";

// Emits `dataset_viewed` once the dataset and page are known, and again when the
// dataset id, title, page or context changes. Reports should key on `dataset_id`:
// `dataset_title` is for readability and changes on rename. `context` names the
// surface (e.g. "nova") and is omitted when absent.
const useTrackDatasetViewed = (
  dataset: Pick<Dataset, "id" | "title"> | undefined,
  page: string | undefined,
  context?: string
) => {
  const datasetId = dataset?.id;
  const datasetTitle = dataset?.title;

  useEffect(() => {
    if (!datasetId || !page) {
      return;
    }
    trackEvent("dataset_viewed", {
      dataset_id: datasetId,
      dataset_title: datasetTitle,
      page,
      ...(context ? { context } : {}),
    });
  }, [datasetId, datasetTitle, page, context]);
};

export default useTrackDatasetViewed;
